import OpeningHours from './opening-hours';
export default OpeningHours;
